
    import { Component, Vue, Prop } from 'vue-property-decorator';

    // Reusable continuous (gradient) legend rendered as a horizontal bar. Colors are
    // ordered low -> high (left -> right). ticks are labels spaced evenly under the bar,
    // left-to-right (2 = the two ends, 3 = ends + middle, etc.). Pass gradientCss to override
    // the evenly-spaced gradient with a custom (e.g. value-positioned) one.
    @Component({
        components: {
        },
    })
    export default class GradientLegend extends Vue {
        @Prop({ default: () => [] }) public colors: string[];
        @Prop({ default: () => [] }) public ticks: string[];
        @Prop({ default: '' }) public gradientCss: string;
        @Prop({ default: '' }) public title: string;

        private get barBackground(): string {
            if (this.gradientCss) return this.gradientCss;
            return this.colors.length > 0 ? `linear-gradient(to right, ${this.colors.join(', ')})` : 'none';
        }

        // First tick hugs the left end, last hugs the right end, any middle ticks centre on
        // their equal-width cell so their position doesn't depend on the end labels' lengths.
        private tickAlign(index: number): string {
            if (index === 0) return 'left';
            if (index === this.ticks.length - 1) return 'right';
            return 'center';
        }
    }
